import { ButtonIcon } from "@insite/mobius/Button";
import { colorPalette } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const clearBtnStyle = css`
    background: none;
    padding: 0;
    border: none;

    &::before,
    &::after {
        content: none;
    }

    &:not(:disabled):hover {
        background: none;
        color: ${colorPalette.common.global.guardianBlue};

        ${ButtonIcon} {
            color: ${colorPalette.common.global.guardianBlue};
        }
    }
`;

export const removeBtnFocusBorder = css`
    &:focus {
        border: none;
        outline: none;
    }
`;
